import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_get_released_tasks_by_workorderIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { workOrderId: number }): 
  Promise<{ result: { Id?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.workOrderId)) {
      $missingRequiredInParams.push('\'workOrderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { workOrderId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.workOrderId)) {
      $missingRequiredInParams.push('\'workOrderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { workOrderId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.workOrderId)) {
      $missingRequiredInParams.push('\'workOrderId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      workOrderId: number    }) {
        if(isNil($inParams.workOrderId)) {
          return true; 
        }
      return false;
    }
}
